import topRightArrow from "../assets/topRightArrow.png";
import linkedin from "../assets/linkedin.png";
import github from "../assets/github.png";
import mail from "../assets/mail.png";
import resume from "../assets/resume.pdf";
let images = [
  "https://img.icons8.com/ios-filled/150/c-plus-plus-logo.png",
  "https://img.icons8.com/ios-glyphs/120/python.png",
  "https://img.icons8.com/ios-glyphs/120/react.png",
  "https://img.icons8.com/ios/150/express-js.png",
  "https://img.icons8.com/material-outlined/192/tailwind_css.png",
];

export default {
  stack: ["C++", "PYTHON", "REACT", "EXPRESS", "TAILWIND"],
  name: ["ANURAG", "NALKAR"],
  arrow: topRightArrow,
  lk: linkedin,
  gh: github,
  ml: mail,
  rs: resume,
  logos: [images[0], images[1], images[2], images[3], images[4]]
};
